import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { RotinaService } from '../rotina.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ProcessoService } from '../../processo/processo.service';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { Router } from '@angular/router';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';
import { RotinaTabsetComponent } from '../rotina-tabset/rotina-tabset.component';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-processos-setores',
  templateUrl: './listar-processos-setores.component.html',
  styleUrls: ['./listar-processos-setores.component.css']
})
export class ListarProcessosSetoresComponent implements OnInit {

  processosSetor: ProcessoSetor[];
  processosCliente: ProcessoCliente[];
  public processosClienteSelecionados: ProcessoCliente[];
  paginacao: Paginacao;
  evento: Evento;
  selecionados: boolean;
  public habilitarSelecaoProcessos: boolean;
  public loading = false;
  public statusCode: number;

  constructor(private _rotinaService: RotinaService,
    private _comumService: ComumService,
    private _processoService: ProcessoService,
    private router: Router,
    private _rotinaTabsetComponent: RotinaTabsetComponent,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.processosSetor = new Array<ProcessoSetor>();
    this.processosCliente = new Array<ProcessoCliente>();
    this.processosClienteSelecionados = new Array<ProcessoCliente>();
    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 2000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    const self = this;

    self._processoService.obterProcessosClienteHttp(parseInt(this._cookieService.get('idCliente'), 10))
      .subscribe(processosCliente => {
        self.processosCliente = processosCliente;
        self.loading = false;
      });

  }

  selecionar(processoCliente: ProcessoCliente): void {
    processoCliente.selecionado = !processoCliente.selecionado;
    if (processoCliente.selecionado) {
      this.processosClienteSelecionados.push(processoCliente);
    } else {
      const index = this.processosClienteSelecionados.indexOf(processoCliente);
      this.processosClienteSelecionados.splice(index, 1);
    }

    if (this.processosClienteSelecionados.length > 0) {
      this.habilitarSelecaoProcessos = true;
    } else {
      this.habilitarSelecaoProcessos = false;
    }
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    if (!this.selecionados) {
      this.habilitarSelecaoProcessos = false;
      this.processosClienteSelecionados = new Array<ProcessoCliente>();
    } else {
      this.habilitarSelecaoProcessos = true;
    }
    this.processosCliente.forEach(processoCliente => {
      if (this.selecionados) {
        this.processosClienteSelecionados.push(processoCliente);
      }
      processoCliente.selecionado = this.selecionados;
    });
  }

  receberRotinasClienteProcesso(rotinasProcesso: RotinaProcesso[]) {
    this.loading = true;
    const rotinasProcessoInsert = new Array<RotinaProcesso>();
    const rotinasProcessoDelete = new Array<RotinaProcesso>();
    rotinasProcesso.forEach(rotinaProcesso => {
      if (!rotinaProcesso.selecionado && rotinaProcesso.idRotinaProcesso !== undefined && rotinaProcesso.alterado) {
        rotinasProcessoDelete.push(rotinaProcesso);
      } else if (rotinaProcesso.selecionado && rotinaProcesso.idRotinaProcesso === undefined
        && rotinaProcesso.alterado) {
        rotinasProcessoInsert.push(rotinaProcesso);
      }
    });
    if (rotinasProcessoDelete.length > 0) {
      this._rotinaService.removerRotinasProcessoHttp(rotinasProcessoDelete)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.atualizar = true;
          this.router.navigate(['rotinas']);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (rotinasProcessoInsert.length > 0) {
      this._rotinaService.cadastrarRotinasProcessoHttp(rotinasProcessoInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.atualizar = true;
          this.router.navigate(['rotinas']);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    this.loading = false;
  }

  voltar(): void {
    this._rotinaTabsetComponent.voltar();
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/listar-processos-setores/listar-processos-setores.component.ts